/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useMemo, useRef, useState } from 'react'
import { I18NextNs } from 'enum/enum';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation } from 'react-router';
import { RouterDOM, FnAxios, FnDialog, I18n } from 'utilities/utilities';
import { Divider, Grid } from '@mui/material';
import { BtnBack, BtnDraft, BtnSave } from 'components/Button/ButtonAll';
import TablePaymentSummary from '../components/Payment/TablePaymentSummary';
import TablePaymentSoldTicket from '../components/Payment/TablePaymentSoldTicket';
import TablePaymentAdd from '../components/Payment/TablePaymentAdd';
import _ from "lodash";
import moment from 'moment';
import { TextAreaItem } from 'components/Input/TextArea';
import { GetMenuPermissionParamRoute } from 'utilities/SystemFunction';

export const ProviderAccPayment = React.createContext(null);


const AccountingPaymentForm = () => {


    //#region Hook
    const Router = RouterDOM();
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    const location = useLocation();
    // #endregion

    const objParamPath = useMemo(() => {
        const ParamId = new URLSearchParams(location.search).get("strParam");
        const ParamPrs = 2;
        return { ParamId, ParamPrs }
    }, [location.search])

    //#region State / Usememo
    const [isPermission, setIsPermission] = useState<boolean>(false);
    const [isView, setIsView] = useState(false)
    const onClearDepositSlip = useRef(null);
    const [arrDepositSlip, setArrDepositSlip] = useState([])
    const [statusId, setStatusId] = useState(0)

    const [objValue, setObjValue] = useState({
        lstSoldTicket: [],
        arrSelectTicketSold: [],
        nAmountTicketSold: 0,
        lstRent: [],
        nAmountRent: 0,
        lstDonate: [],
        nAmountDonate: 0,
    })

    //#region Form
    const form = useForm({
        shouldFocusError: true,
        shouldUnregister: false,
        mode: "all",
        defaultValues: {
            dDatePayment: null,
            dDateDeposit: null,
            sRemarkFlow: null,
            nStartDate: null,
            nEndDate: null,
        }
    });
    // #endregion

    useEffect(() => {
        GetMenuPermissionParamRoute("/AccountingPaymentList", AxiosFn, setIsPermission, DialogFn);
    }, []);

    const objProvider = React.useMemo(() => (
        {
            statusId,
            isView : isPermission ? isView : true,
            form,
            onClearDepositSlip,
            arrDepositSlip,
            setArrDepositSlip,
            objValue,
            setObjValue
        }
    ), [statusId, isView, form, arrDepositSlip, objValue,isPermission]);

    useEffect(() => {
        getOptionInitialData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const gotoBack = () => {
        Router.GoToPage("/AccountingPaymentList")
    }


    // const hasBtnReject = useMemo(() => {

    //     let isHasReject = dataTable.findIndex(f=>f.nStatusID !== 2) > -1
    //     return isHasReject
    // }, [dataTable])

    const handleSubmitForm = (sMode) => {
        if (arrDepositSlip.length === 0 && sMode === "S") {
            DialogFn.Warning("กรุณาระบุใบนำฝาก")
            return;
        }
        let nTotal = objValue.nAmountTicketSold + objValue.nAmountRent + objValue.nAmountDonate;
        if (nTotal === 0) {
            DialogFn.Warning("กรุณาระบุข้อมูล รายการจำหน่ายตั๋ว รายการค่าเช่า เงินบริจาค อย่างใดอย่างหนึ่ง")
            return;
        }

        let lstSoldTicket = _.cloneDeep(objValue.lstSoldTicket);

        let isHasReject = lstSoldTicket.findIndex(f=>f.nStatusID === 2)
        if(isHasReject > -1)
        {
            DialogFn.Warning("ไม่สามารถนำส่งการเงินส่วนกลางได้ เนื่องจากรายการจำหน่ายมีสถานะถูกส่งกลับแก้ไข")
            return;
        }
        form.clearErrors()
        let lstSoldSelect = lstSoldTicket.filter(item => objValue.arrSelectTicketSold.includes(item.nID)).map(item => ({
            nID: item.nID,
            sRemark: item.sRemark,
        }));


        let objParam = {
            sMode: sMode,
            sIDPayment: objParamPath.ParamId,
            lstSelectTicketSold: lstSoldSelect,
            nAmountTicketSold: objValue.nAmountTicketSold,
            lstRent: objValue.lstRent,
            nAmountRent: objValue.nAmountRent,
            lstDonate: objValue.lstDonate,
            nAmountDonate: objValue.nAmountDonate,
            nTotal: nTotal,
            nDatePayment: form.getValues("dDatePayment") ? form.getValues("dDatePayment").valueOf() : null,
            nDateDeposit: form.getValues("dDateDeposit") ? form.getValues("dDateDeposit").valueOf() : null,
            nStartDate: form.getValues("nStartDate") ? form.getValues("nStartDate").valueOf() : null,
            nEndDate: form.getValues("nEndDate") ? form.getValues("nEndDate").valueOf() : null,
            lstFile: arrDepositSlip,
            sRemark: "",
        };

        DialogFn.Submit(I18n.SetText("Message.ConfirmSave", I18NextNs.labelComponent), () => {
            AxiosFn.Post(`PaymentTicket/OnSubmitPayment`, objParam, () => {
                DialogFn.Success(I18n.SetText("Message.SaveComplete", I18NextNs.labelComponent), () => {
                    gotoBack();
                });
            });
        });
    }

    const getOptionInitialData = () => {
        if (objParamPath.ParamId) {

            DialogFn.BlockUI();
            AxiosFn.Get(`PaymentTicket/GetFormInfoPayment`, { sPaymentID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let lstTicketSold = result.objResult.lstTicketSold
                let lstSelectTicketSold = result.objResult.lstSelectTicketSold

                let objPayment = result.objResult.objPayment;
                setStatusId(parseInt(objPayment.nStatusID))
                setIsView([1, 3].includes(objPayment.nStatusID))
                form.setValue("dDatePayment", moment(objPayment.nDatePayment))
                form.setValue("dDateDeposit", moment(objPayment.nDateDeposit))
                form.setValue("nStartDate", moment(objPayment.nStartDate))
                form.setValue("nEndDate", moment(objPayment.nEndDate))
                form.setValue("sRemarkFlow", objPayment.sRemark)
                setArrDepositSlip(objPayment.lstFile)
                setObjValue(value => {
                    return ({
                        ...value,
                        lstSoldTicket: lstTicketSold,
                        arrSelectTicketSold: lstSelectTicketSold,
                        nAmountTicketSold: objPayment.nAmountTicketSold,
                        lstRent: objPayment.lstRent,
                        nAmountRent: objPayment.nAmountRent,
                        lstDonate: objPayment.lstDonate,
                        nAmountDonate: objPayment.nAmountDonate,
                    })
                })
            });
            return;
        }
        DialogFn.BlockUI();
        AxiosFn.Get(`PaymentTicket/GetFormInitialPayment`, null, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;

            setObjValue(value => {
                return ({
                    ...value,
                    lstSoldTicket: objResult.lstTicketSold,

                })
            })

        });
    };

    const getPaymentSoldTicket = () => {
        if (objParamPath.ParamId) {
            DialogFn.BlockUI();
            AxiosFn.Get(`PaymentTicket/GetFormInfoPayment`, { sPaymentID: objParamPath.ParamId }, (result) => {
                DialogFn.UnBlockUI();
                let lstTicketSold = result.objResult.lstTicketSold
                let lstSelectTicketSold = result.objResult.lstSelectTicketSold
                let objPayment = result.objResult.objPayment;
           
                setObjValue(value => {
                    return ({
                        ...value,
                        lstSoldTicket: lstTicketSold,
                        arrSelectTicketSold: lstSelectTicketSold,
                        nAmountTicketSold: objPayment.nAmountTicketSold,
                    })
                })
            });
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <ProviderAccPayment.Provider value={objProvider} >
                    <Grid container spacing={2.5}>
                        <Grid item xs={12}>
                            <TablePaymentSoldTicket menu={"Payment"} sIDPayment={objParamPath.ParamId} getPaymentSoldTicket={getPaymentSoldTicket}/>
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                            <TablePaymentAdd isRent={true} />
                        </Grid>
                        <Grid item xs={12}>
                            <br />
                            <TablePaymentAdd isRent={false} />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                <FormProvider {...form}>
                                    <Grid item xs={12}>
                                        <br />
                                        <TablePaymentSummary />
                                    </Grid>
                                    {statusId === 2 && <Grid item xs={12}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Divider textAlign="left" className="font-weight-500 red">เหตุผลจากการเงินส่วนกลาง</Divider>
                                            </Grid>
                                            <Grid item xs={12} >
                                                <TextAreaItem
                                                    id='sRemarkFlow'
                                                    name='sRemarkFlow'
                                                    required={false}
                                                    disabled
                                                    label={"เหตุผล"}
                                                    maxLength={250}
                                                    placeholder={"เหตุผล"}
                                                    row={3}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>}
                                </FormProvider>
                            </Grid>
                        </Grid>
                    </Grid>
                </ProviderAccPayment.Provider>
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
                {/* Button */}
                <Grid
                    container
                    spacing={2}
                    justifyContent={"space-between"}
                    alignItems={"start"}
                >
                    <Grid item>
                        <BtnBack id={"btnback-ticket"} onClick={() => gotoBack()} />
                    </Grid>
                    <Grid item>
                        {isView ? null :
                            <Grid
                                container
                                spacing={2}
                                justifyContent={"end"}
                                alignItems={"start"}
                            >
                                {statusId !== 2 && <Grid item>
                                    <BtnDraft
                                        id={"btndraft-ticket"}
                                        onClick={form.handleSubmit(() => handleSubmitForm("D"))}
                                    />
                                </Grid>}
                                <Grid item>
                                    <BtnSave
                                        id={"btnsave-ticket"}
                                        txt="นำส่งการเงินส่วนกลาง"
                                        onClick={form.handleSubmit(() => handleSubmitForm("S"))}
                                    />
                                </Grid>
                            </Grid>}
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default AccountingPaymentForm